export default __webpack_public_path__ + "static/media/Vector.0535ad06.svg";